import {axiosGet, urlGenerator} from "../../../common/Helper/AxiosHelper";
import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {formatDateToLocal} from "../../../common/Helper/Support/DateTimeHelper";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        return {
            urlGenerator,
            options: {
                name             : this.$t('support_email'),
                url              : `${TENANT_BASE_URL}app/settings/support-email`,
                showHeader       : true,
                tableShadow      : false,
                tablePaddingClass: 'pt-primary',
                columns          : [
                    {
                        title    : this.$t('actions'),
                        type     : 'action',
                        key      : 'id',
                        isVisible: true
                    },
                    {
                        title    : this.$t('email'),
                        type     : 'text',
                        key      : 'email',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('category'),
                        type     : 'custom-html',
                        key      : 'category_list',
                        isVisible: true,
                        modifier : (value) => {
                            if (value && value.length > 0) {
                                return value.join(', ')
                            }

                            return '';
                        }
                    },
                    {
                        title    : this.$t('remark'),
                        type     : 'custom-html',
                        key      : 'remark',
                        isVisible: true,
                        modifier : (value) => {
                            return value;
                        }
                    },
                    {
                        title    : this.$t('created_by'),
                        type     : 'custom-html',
                        key      : 'created_by',
                        isVisible: true,
                        modifier : (data) => {
                            return data.full_name;
                        }
                    },
                    {
                        title    : this.$t('created'),
                        type     : 'custom-html',
                        key      : 'created_at',
                        isVisible: true,
                        modifier : (value) => {
                            return formatDateToLocal(value);
                        }
                    },
                ],
                filters          : [
                    {
                        title : this.$t('created'),
                        type  : "range-picker",
                        key   : "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title         : this.$t('category'),
                        type          : "multi-select-filter",
                        key           : "category_id",
                        option        : [],
                        listValueField: 'name',
                    },
                ],
                paginationType   : "pagination",
                responsive       : true,
                rowLimit         : 10,
                showAction       : true,
                orderBy          : 'desc',
                actionType       : 'default',
                actions          : [
                    {
                        title: this.$t('edit'),
                        icon : 'edit',
                        type : 'modal',
                    },
                    {
                        title    : this.$t('delete'),
                        icon     : 'trash-2',
                        type     : 'modal',
                        component: 'app-confirmation-modal',
                        modalId  : 'app-confirmation-modal',
                        url      : `${TENANT_BASE_URL}app/settings/support-email`,
                        name     : 'delete',
                    }
                ],
            }
        }
    },
    mounted() {
        const categoryFilter = this.options.filters.find(item => item.key === 'category_id');

        axiosGet(`${TENANT_BASE_URL}selectable/ticket/category`)
            .then(({data}) => categoryFilter.option = data)
            .catch(error => this.$toastr.e(error.response.data.message))
    },
}